import React, {useMemo} from 'react'
import { styled } from '@mui/material/styles'
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ToggleButton,
  Button,
  Typography,
  TextField,
} from '@mui/material'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#484848',
    color: '#fff',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))
const StyledToggleButton = styled(ToggleButton)({
  padding: '3px 15px',
  '&.Mui-selected': {
    borderColor: '#1976d2',
    color: '#1976d2',
    backgroundColor: '#fff',
    '&:hover': {
      borderColor: '#1976d2',
      color: '#1976d2'
    }
  }
})
const StyledButton = styled(Button)({
  color: '#fff'
})

// const initData = {
//   dateRange: [null, null]
// }

const questionList = [
  {
    id: 1,
    question: '이번 주 인지하신 임원 변동이 있으신가요? (신규 선임 또는 사임 등)'
  },
  {
    id: 2,
    question: '이번 주 인지하신 기업 변동이 있으신가요? (합병 또는 자회사 설립 등)'
  }
]

const TableItem = ({
  index,
  item,
  selected,
  toggleSelect,
}) => {

  return (
    <TableRow
      hover
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        {item.question}
      </TableCell>
      <TableCell align="center">
        <StyledToggleButton
          color="primary"
          selected={selected}
          exclusive
          onChange={() => {
            toggleSelect({
              index,
              selected: true
            })
          }}
        >
          Y
        </StyledToggleButton>
      </TableCell>
      <TableCell align="center">
        <StyledToggleButton
          color="primary"
          selected={!selected}
          exclusive
          onChange={() => {
            toggleSelect({
              index,
              selected: false
            })
          }}
        >
          N
        </StyledToggleButton>
      </TableCell>
    </TableRow>
  )
}

const MonitoringTable = ({
  data,
  selecteds,
  etcs,
  toggleSelect,
  changeEtc,
  allGroupSelect
}) => {
  const {companyId} = data
  const handleToggleSelect = ({
    index,
    selected
  }) => {
    toggleSelect({
      index,
      selected,
      key: companyId
    })
  }

  const handleChangeEtc = (e) => {
    changeEtc({
      key: companyId,
      value: e.target.value
    })
  }

  const isShowEtcForm = useMemo(() => {
    if (!selecteds[companyId]) return []
    return selecteds[companyId].find(data => data)
  }, [selecteds, companyId])

  return (
    <TableContainer component={Paper} sx={{marginTop: 3}}>
      <Table sx={{ minWidth: 650 }} size="mini">
        <TableHead>
          <TableRow>
            <StyledTableCell>
              <Typography variant="h6" component="div" sx={{ml: 1}}>{data.companyName}</Typography>
            </StyledTableCell>
            <StyledTableCell width="10%" align="center">
              <StyledButton onClick={() => allGroupSelect(data.companyId, true)}>예</StyledButton>
            </StyledTableCell>
            <StyledTableCell width="10%" align="center">
              <StyledButton onClick={() => allGroupSelect(data.companyId, false)}>아니오</StyledButton>
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            questionList.map((item, index) => {
              return (
                <TableItem 
                  item={item} 
                  key={index}
                  selected={selecteds[companyId][index]}
                  toggleSelect={handleToggleSelect}
                  index={index}
                /> 
              )
            })
          }
          {
            isShowEtcForm && <TableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell colSpan={3}>
                <TextField
                  autoFocus
                  fullWidth
                  multiline
                  rows={2}
                  defaultValue={etcs[companyId]}
                  onChange={handleChangeEtc}
                  sx={{backgroundColor: '#f9f9f9'}}
                  placeholder={`변동 사항의 내용을 기재해주시고, 임원 신규 선임/사임이 수반되는 경우 '임원 정보'를 등록해주세요.\n이전에 공유한 변동 사항과 내용이 일치하는 경우 간략하게 작성해주세요.`}
                />
              </TableCell>
            </TableRow>
          }
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default MonitoringTable